import { getWidthPercents } from '../../utils';

export const EmptySpace = () => (index: number) => `
<mj-column width="${getWidthPercents(index)}" padding="0">
  <mj-text height="38px" padding="0"></mj-text>
</mj-column>`;